import throttle from "../utils/throttle";

const NavComponent = (el) => {
  const firstSection = document.querySelector("body section:first-child");
  let scrollDir = 0;
  let prevScrollY;
  let scrollTimeoutID;

  const onScroll = () => {
    scrollDir =
      prevScrollY && window.scrollY > prevScrollY
        ? 1
        : prevScrollY && window.scrollY < prevScrollY
          ? -1
          : 0;

    if (
      window.scrollY + el.offsetHeight > firstSection.offsetHeight &&
      !el.classList.contains("is-dark")
    ) {
      el.classList.add("is-dark");
    } else if (
      window.scrollY + el.offsetHeight <= firstSection.offsetHeight &&
      el.classList.contains("is-dark")
    ) {
      el.classList.remove("is-dark");
    }

    if (scrollDir === 1 && window.scrollY >= 20) {
      el.classList.add("hide");
      if (scrollTimeoutID) clearTimeout(scrollTimeoutID);
      scrollTimeoutID = null;
    } else if (
      scrollDir === -1 &&
      !scrollTimeoutID &&
      el.classList.contains("hide")
    ) {
      scrollTimeoutID = setTimeout(() => {
        el.classList.remove("hide");
        clearTimeout(scrollTimeoutID);
        scrollTimeoutID = null;
      }, 200);
    }

    prevScrollY = window.scrollY;
  };
  window.addEventListener("scroll", throttle(onScroll, 200));
  onScroll();
};

export default NavComponent;
